/*
 * The two things the phone cart drawer cannot do in CSS alone — see
 * tc-cart-compact.css for what the layout is and why.
 *
 * 1. The suggestions row keeps shirts and accessories only. The list is
 *    Shopify's recommendations for the first thing in the basket, and for a
 *    suit that is mostly more suits, plus the trouser swap and the protection
 *    product — none of which is a thing to add to a suit on the way out.
 * 2. Delivery protection is one line; its explanation opens from an "i".
 *
 * The drawer is rebuilt on every basket change, and both the suggestions and
 * the protection row arrive after it, from their own scripts. So this watches
 * the drawer and tidies whatever turns up, rather than running once.
 */
(function () {
  var SKIP = /suit|trousers-swap|truclothing-protection/;

  function prune(root) {
    var lists = root.querySelectorAll('cc-cart-cross-sell');
    for (var i = 0; i < lists.length; i++) {
      var items = lists[i].querySelectorAll('.slider__item');
      if (!items.length) continue; // not loaded yet: say nothing about it
      var kept = 0;
      for (var j = 0; j < items.length; j++) {
        var link = items[j].querySelector('a.product-link');
        var path = link ? (link.getAttribute('href') || '').split('?')[0] : '';
        var off = SKIP.test(path);
        if (items[j].classList.contains('tc-chip-off') !== off) items[j].classList.toggle('tc-chip-off', off);
        if (!off) kept++;
      }
      var count = String(kept);
      if (lists[i].getAttribute('data-tc-chips') !== count) lists[i].setAttribute('data-tc-chips', count);
    }
  }

  function info(root) {
    var rows = root.querySelectorAll('.tc-protect');
    for (var i = 0; i < rows.length; i++) {
      var title = rows[i].querySelector('.tc-protect__title');
      var note = rows[i].querySelector('.tc-protect__note');
      if (!title || !note || rows[i].querySelector('.tc-protect__info')) continue;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tc-protect__info';
      button.textContent = 'i';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', note.textContent.trim() ? title.textContent.trim() + ': ' + note.textContent.trim() : title.textContent.trim());
      title.parentNode.insertBefore(button, title.nextSibling);
    }
  }

  // The row is a <label>, so a tap anywhere in it ticks the box. Not this one.
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.tc-protect__info');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    var open = button.closest('.tc-protect').classList.toggle('tc-protect--open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);

  function tidy() {
    var drawers = document.querySelectorAll('cart-form.cart-drawer');
    for (var i = 0; i < drawers.length; i++) { prune(drawers[i]); info(drawers[i]); }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tidy(); });
  }

  function start() {
    tidy();
    var drawer = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(soon).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
